import { AsyncActions } from '@telstra-connect/standard-actions/';
import { BILLING_REMOVE_DEBITCARD_DETAIL } from './action-types';
import { IRemoveDirectDebit } from '../state/remove-direct-debit';

export interface IRemoveDirectDebitAction extends AsyncActions.IAsyncFetchableAction
<BILLING_REMOVE_DEBITCARD_DETAIL> {
}

export interface IRemoveDirectDebitSuccessAction extends AsyncActions.IAsyncAction<BILLING_REMOVE_DEBITCARD_DETAIL> {
    data: IRemoveDirectDebit;
}

export type IRemoveDirectDebitErrorAction = AsyncActions.IAsyncErrorAction<BILLING_REMOVE_DEBITCARD_DETAIL>;

export const RemoveDirectDebitStart = (): IRemoveDirectDebitAction => ({
    status: AsyncActions.AsyncActionState.Initiated,
    type: BILLING_REMOVE_DEBITCARD_DETAIL,
    isFetchable: true
});

export const RemoveDirectDebitSuccess = (data: IRemoveDirectDebit): IRemoveDirectDebitSuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: BILLING_REMOVE_DEBITCARD_DETAIL,
    data
});

export const RemoveDirectDebitError = (error: string, errorCode?: string): IRemoveDirectDebitErrorAction => ({
    status: AsyncActions.AsyncActionState.Failure,
    type: BILLING_REMOVE_DEBITCARD_DETAIL,
    error,
    errorCode
});

export const RemoveDirectDebitInitial = (): IRemoveDirectDebitAction => ({
    status: AsyncActions.AsyncActionState.NotStarted,
    type: BILLING_REMOVE_DEBITCARD_DETAIL,
    isFetchable: true
});
